import "./style.less";

export default function basketPrice() {
    return {
        restrict: "E",
        scope: {},
        template: require("./template.html"),

        controller: function ($scope, $rootScope, Basket) {
            //listen to event - hides price
            var AnyRepeatableCollasedEventListener = $scope.$on(
                "any-repeabable-collapsed",
                function (event, obj) {
                    $scope.anyRepeatableCollapsed = obj.collapsed;
                }
            );
            $scope.$on("$destroy", AnyRepeatableCollasedEventListener);

            $scope.getTotal = function () {
                var total = 0;

                for (var i = 0; i < Basket.currentBookings.length; i++) {
                    var booking = Basket.currentBookings[i];
                    total += booking.Price;
                }

                return total;
            };
        },
    };
}
